//overrides for `sort by` options since shopify does not expose it in it's translation system

document.addEventListener('DOMContentLoaded', () => {
    const locale = Shopify.locale;

    const sortingLabelsByLocale = {
        sk: {
            "Odporúčané": "Odporúčané",
            "Najrelevantnejšie": "Najrelevantnejšie",
            "Najpredávanejšie": "Najpredávanejšie",
            "Abecedne, od A po Z": "Abecedne, od A po Z",
            "Abecedne, od Z po A": "Abecedne, od Z po A",
            "Cena, od najnižšej po najvyššiu": "Cena: od najnižšej",
            "Cena, od najvyššej po najnižšiu": "Cena: od najvyššej",
            "Dátum, od najstarších po najnovšie": "Od najstarších",
            "Dátum, od najnovších po najstaršie": "Od najnovších"
        },
        de: {
            
        },
        cz: {
            
        }
    };

    const sortingLabels = sortingLabelsByLocale[locale];

    if (!sortingLabels) return;

    document.querySelectorAll('select[name="sort_by"] option').forEach(option => {
        if (sortingLabels[option.text]) {
            option.text = sortingLabels[option.text];
        }
    });
});